"use client";

import CustomHeaderV4 from "@/app/(custom-header)/header/CustomHeaderV4";
import BotbPassMembersHomePageContent from "./page-content";

export default function BotbPassMembersHomePage() {
  return (
    <>
      <CustomHeaderV4 />
      <main className="botb-pass-members-main-section">
        <BotbPassMembersHomePageContent />
      </main>
    </>
  );
}
